// Featured host: David Porter
export const HOST = {
  id: "6a924e6583d62422c8f43426",
  name: "David Porter",
  title: "Pastor",
  role: "Host · The Gospel Show",
  photo: "https://customer-assets-rejwkqb3.emergentagent.net/job_praise-fm-1/artifacts/7oymz8dy_ai-generated-photo.png",
  bio: "With a heart for worship and a voice that feels like home, David Porter has spent years walking alongside believers through song, scripture and prayer. On The Gospel Show he brings spirit-filled conversation, uplifting gospel and honest, come-as-you-are prayer. Whether you're celebrating or carrying a heavy load, pull up a seat — there's always room at this table.",
  tags: ["Praise & Worship", "Prayer & Encouragement", "Live Call-ins", "Testimonies"],
};

// David's weekly live schedule (local time). day: 0=Sun ... 6=Sat.
export const HOST_SCHEDULE = [
  { day: 0, hour: 9, minute: 0, title: "Sunday Praise" },
  { day: 3, hour: 19, minute: 0, title: "Midweek Worship" },
  { day: 5, hour: 20, minute: 0, title: "Friday Night Gospel" },
];

// Returns the next upcoming show { title, date } based on the weekly schedule.
export function nextLive(now = new Date()) {
  let best = null;
  for (let ahead = 0; ahead < 8; ahead++) {
    const d = new Date(now);
    d.setDate(now.getDate() + ahead);
    for (const slot of HOST_SCHEDULE) {
      if (d.getDay() !== slot.day) continue;
      const when = new Date(d);
      when.setHours(slot.hour, slot.minute, 0, 0);
      if (when > now && (!best || when < best.date)) best = { title: slot.title, date: when };
    }
  }
  return best;
}

export function formatNextLive(next) {
  if (!next) return "";
  const opts = { weekday: "long", hour: "numeric", minute: "2-digit" };
  return next.date.toLocaleString(undefined, opts);
}
